import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { colors, fontFamily, maxWidth } from "./tokens";
import Reveal from "./Reveal";

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(12, 3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(8, 2.5)
    }
  },
  inner: {
    maxWidth,
    margin: "0 auto"
  },
  headline: {
    fontFamily,
    fontWeight: 700,
    letterSpacing: "-0.03em",
    fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
    color: colors.ink,
    textAlign: "center",
    margin: 0,
    marginBottom: theme.spacing(8)
  },
  track: {
    display: "flex",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  step: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: theme.spacing(0, 2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      alignItems: "flex-start",
      textAlign: "left",
      width: "100%",
      padding: theme.spacing(0, 0, 4)
    }
  },
  markerRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "auto",
      marginRight: theme.spacing(2.5),
      marginBottom: 0
    }
  },
  line: {
    flex: 1,
    height: 1,
    background: colors.border,
    [theme.breakpoints.down("sm")]: {
      width: 1,
      flex: 1,
      minHeight: 32
    }
  },
  lineHidden: {
    background: "transparent"
  },
  bubble: {
    flexShrink: 0,
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: `1px solid ${colors.border}`,
    background: colors.surface,
    color: colors.ink,
    fontFamily,
    fontWeight: 700,
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  bubbleActive: {
    background: colors.ink,
    color: "#fff",
    borderColor: colors.ink
  },
  stepTitle: {
    fontFamily,
    fontWeight: 600,
    fontSize: 15,
    color: colors.ink,
    marginBottom: 4
  },
  stepText: {
    fontFamily,
    fontSize: 13,
    lineHeight: 1.55,
    color: colors.inkMuted,
    maxWidth: 220,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "none"
    }
  }
}));

const steps = [
  { title: "Asset", text: "A tracked piece of equipment needs attention." },
  { title: "Service Request", text: "The issue is logged and routed to a provider." },
  { title: "Work Order", text: "Accepted work is scheduled and assigned." },
  { title: "Maintenance", text: "Technicians act, report findings and use materials." },
  { title: "Completion", text: "Work is closed out and recorded for reporting." }
];

export default function Workflow() {
  const classes = useStyles();

  return (
    <section id="how-it-works" className={classes.section}>
      <div className={classes.inner}>
        <Reveal as="h2" className={classes.headline}>
          From issue to completion.
        </Reveal>

        <div className={classes.track}>
          {steps.map((step, i) => (
            <Reveal as="div" className={classes.step} delay={i * 90} key={step.title}>
              <div className={classes.markerRow}>
                <span className={`${classes.line} ${i === 0 ? classes.lineHidden : ""}`} />
                <span className={`${classes.bubble} ${i === steps.length - 1 ? classes.bubbleActive : ""}`}>
                  {i + 1}
                </span>
                <span className={`${classes.line} ${i === steps.length - 1 ? classes.lineHidden : ""}`} />
              </div>
              <div>
                <div className={classes.stepTitle}>{step.title}</div>
                <div className={classes.stepText}>{step.text}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
